setTimeout(function(){

    var LeavingMessagePage = {
        init: function(){
            let whitelistForm = $('form.whitelist');
            if($('body').hasClass('admin') && whitelistForm.length > 0){
                console.log('whitelist controls initialized');
                whitelistForm.submit(LeavingMessagePage.addWhitelistItem);
                whitelistForm.find('.remove-item').click(LeavingMessagePage.removeWhitelistItem);
            }
        },
        addWhitelistItem: function(e){
            e.preventDefault();
            // console.log('test');
            let self = $(this);
            $.post('/admin/white-list', self.serialize(), function(r) {
                if ( r.success ) {
                    LeavingMessagePage.appendItem(r.data);
                    $('.whitelist .new-item').val('');
                } else {
                    console.log(r);
                }
            });
        },
        appendItem: function(item) {
            let li = $('<li>').text(item.url),
                btn = $('<button type="button" class="ui red button remove-item">').attr('data-id', item.id).html('&times;');
            btn.appendTo(li);
            li.appendTo($('.whitelist ul'));
        },
        removeWhitelistItem: function(e){
            let id = $(this).data('id');
            $.post('/admin/white-list/remove', {'id':id}, function(r){
                if(r.success){
                    $('[data-id="'+id+'"]').parent().fadeOut(function() {
                        $('[data-id="'+id+'"]').parent().remove();
                    });
                } else {console.log(r);}
            });
        }
    };

    $(document).ready(LeavingMessagePage.init);

    var moodyBank = {
        whiteList: [],
        init: function(){
            moodyBank.getWhitelist();
            $('body').removeClass('loading');
            $('a').each(function(i, e){moodyBank.initAnchor(e);});
        },
        getWhitelist: function(){
            // console.log($('#leaving_whitelist').find('.whitelisted-site'));
            moodyBank.whiteList = $('#leaving_whitelist').find('.whitelisted-site').map(function(i, e){
                // console.log($(e).data('url'));
                return $(e).data('url');
            }).get();
        },
        initAnchor: function(e){
            let regDoubleSlash = /^([^/:]*:)?(\/\/)/i;
            let regLocal = /^([^/:]*:)?(\/\/)([^/:]+\.)?(staging\.moodybank(2?)\.liquidfish|moodybank|loanwebcenter|netteller)\.(com|dev|test)/i;
            let $e = $(e);
            let href = e.href;
            if(regDoubleSlash.test(href) && !regLocal.test(href)) {
                $e.click(function(e2){
                    if(!moodyBank.whiteList.includes(href)){
                        e2.preventDefault();
                        if(confirm($('#leaving_message').html())){
                            window.open(this.href, '_blank');
                        }
                    }
                });
            }

        }
    };

    $(document).ready(moodyBank.init());
}, 1000);


// WEBPACK FOOTER //
// ./resources/assets/js/LeavingMessage.js